import { useEffect, useState } from 'react';
import { paramCase } from 'change-case';
import { useParams, useLocation } from 'react-router-dom';
// material
import { Container } from '@mui/material';
// redux
import { useDispatch, useSelector, RootState } from '../../../redux/store';
import { getUserList } from '../../../redux/slices/user';
// routes
import { Link as RouterLink, Navigate } from 'react-router-dom';
// hooks
import useSettings from '../../../hooks/useSettings';
// components
import Page from '../../../components/Page';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import useAuth from '../../../hooks/useAuth';
import { axios } from 'utils/axios';
import CompanyCreateForm from 'components/_dashboard/company/CompanyNewForm';
// ----------------------------------------------------------------------

export default function CompanyCreate() {
  const { themeStretch } = useSettings();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { id = '' } = useParams();
  const [contactInfo, setContactInfo] = useState<any>({});
  const isEdit = pathname.includes('edit');
  const isDetails = pathname.includes('details');
  // const currentUser = userList.find((user) => paramCase(user.userID) === id);
  const [redirect, setRedirect] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    console.log(user?.role, 'user.role');
    if (user?.role !== 'admin') {
      setRedirect(true);
    }
    if (!isEdit) {
      setContactInfo({});
    }
    fetchContactInfo();
  }, [isEdit]);

  const fetchContactInfo = async () => {
    const response = await axios.get(`/rest/api/company/info/${id}`);
    console.log(response.data);
    setContactInfo(response.data.data);
  };
  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);
  function redirectTo() {
    return <Navigate to="/dashboard/inspections" />;
  }

  if (redirect) return redirectTo();
  return (
    <Page title={`Contact: ${isEdit ? 'Edit' : isDetails ? 'Details' : 'Create'} a Contact`}>
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading={isDetails ? 'Contact Details' : isEdit ? 'Edit Contact' : 'Create a New Contact'}
          links={[
            { name: 'Dashboard', href: '/dashboard' },
            { name: 'Companies', href: '/dashboard/companies' },
            { name: isDetails ? 'Details' : isEdit ? 'Edit' : 'New Company' }
          ]}
        />
        <CompanyCreateForm isEdit={isEdit} isDetails={isDetails} currentUser={contactInfo} />
      </Container>
    </Page>
  );
}
